import React, { useState } from 'react';

import CSVReader from 'react-csv-reader';
import styled, { css } from 'styled-components';

export type CsvDataRow = Array<string>;

export function TotemCsvInputButton({
    onCsvDataUpload,
    disabled,
    label,
}: {
    onCsvDataUpload: (data: Array<CsvDataRow>) => void;
    disabled?: boolean;
    label?: string;
}) {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const handleCsvUpload = (data: Array<CsvDataRow>) => {
        setIsLoading(true);
        if (data?.length) {
            onCsvDataUpload(data);
        }
        setIsLoading(false);
    };

    const usedLabel = label ?? 'Sélectionner un fichier CSV';

    // With the CsvReader, we cannot add the same file twice. Therefore we did a hack :
    // we use the isLoading props to unmount the CSVReader component so it's reinitialise
    return (
        <ReaderContainer $disabled={disabled || isLoading}>
            {isLoading ? (
                <div>
                    <label>{usedLabel}</label>
                </div>
            ) : (
                <CSVReader label={usedLabel} onFileLoaded={handleCsvUpload} disabled={disabled || isLoading} />
            )}
        </ReaderContainer>
    );
}

const ReaderContainer = styled.div<{ $disabled?: boolean }>`
    margin-right: 5px;
    > div {
        display: flex;

        > label {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-height: 44px;
            text-align: center;
            padding: 0 20px;
            color: ${({ theme }) => theme.ctaPrimaryTextColor};
            background-color: ${({ theme }) => theme.ctaPrimaryColor};
            font-size: 15px;
            font-weight: 800;
            text-transform: uppercase;
            letter-spacing: 1.5px;
            border: 0;
            border-radius: 8px;
            cursor: pointer;
            user-select: none;
            transition: opacity 0.2s ease;

            &:hover {
                opacity: 0.85;
            }
            ${({ $disabled }) =>
                $disabled &&
                css`
                    opacity: 0.5;
                    cursor: default;
                    pointer-events: none;
                `}
        }
        > input {
            display: none;
        }
    }
`;
